import { c as _c } from "react/compiler-runtime";
import { Circle, Separator, HStack, Icon, IconButton, Link } from '@chakra-ui/react';
import { CardCarouselControlProps } from '@src/components/sco/CardCarousel/Controls/CardCarouselControlProps';
import React, { useEffect, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { MdOutlinePause, MdPlayArrow } from 'react-icons/md';
export const TopControlMobile = props => {
  const $ = _c(28);
  const t0 = props.activeItemIndex === 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      bgColor: "none"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== props) {
    t2 = () => props.prevItem();
    $[1] = props;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon asChild={true} boxSize={4}><FiChevronLeft /></Icon>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t0 || $[5] !== t2) {
    t4 = <IconButton aria-label="Previous Item" disabled={t0} size="sm" title="Previous Item" variant="ghost" _hover={t1} onClick={t2}>{t3}</IconButton>;
    $[4] = t0;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props) {
    t5 = props.pages.map((_, i) => <Link key={i} display="block" opacity={i === props.activePageIndex ? 1 : 0.3} _hover={{
      opacity: 1
    }} onClick={() => props.goToPage(i)}><Circle bgColor="actionPrimary" boxShadow={i === props.activePageIndex ? "0px 0px 6px #AFC5E8" : "none"} margin="0.2em" size="0.4em" /></Link>);
    $[7] = props;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <HStack align="center" justify="center" width="full">{t5}</HStack>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = props.activeItemIndex === props.items.length - 1;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      bgColor: "none"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== props) {
    t9 = () => props.nextItem();
    $[12] = props;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Icon asChild={true} boxSize={4}><FiChevronRight /></Icon>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t7 || $[16] !== t9) {
    t11 = <IconButton aria-label="Next Item" disabled={t7} size="sm" title="Next Item" variant="ghost" _hover={t8} onClick={t9}>{t10}</IconButton>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t4 || $[20] !== t6) {
    t12 = <HStack width="full">{t4}{t6}{t11}</HStack>;
    $[18] = t11;
    $[19] = t4;
    $[20] = t6;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator borderColor="backgroundTertiary" height="1em" orientation="vertical" />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== props) {
    t14 = props.autoCycleState.isDisabled === false && <AutoCycleControl {...props} />;
    $[23] = props;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t12 || $[26] !== t14) {
    t15 = <HStack align="center" gap={0} justify="center" marginBottom={2} width="full"><HStack width="full">{t12}{t13}{t14}</HStack></HStack>;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
};
export const AutoCycleControl = props => {
  const $ = _c(7);
  const [, setNextTransitionAt] = useState(null);
  let t0;
  if ($[0] !== props.autoCycleState.isPaused || $[1] !== props.autoCycleState.nextTransitionAt) {
    t0 = () => {
      if (!props.autoCycleState.isPaused) {
        setNextTransitionAt(props.autoCycleState.nextTransitionAt);
      }
    };
    $[0] = props.autoCycleState.isPaused;
    $[1] = props.autoCycleState.nextTransitionAt;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.autoCycleState.nextTransitionAt) {
    t1 = [props.autoCycleState.nextTransitionAt];
    $[3] = props.autoCycleState.nextTransitionAt;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== props) {
    t2 = <HStack align="center" gap={1}>{props.autoCycleState.isPaused ? <IconButton aria-label="Play" size="sm" title="Play" variant="ghost" _hover={{
        bgColor: "none"
      }} onClick={() => props.updateAutoCycleState({
        isPaused: false
      })}><Icon asChild={true} boxSize={4}><MdPlayArrow /></Icon></IconButton> : <IconButton aria-label="Pause" size="sm" title="Pause" variant="ghost" _hover={{
        bgColor: "none"
      }} onClick={() => props.updateAutoCycleState({
        isPaused: true
      })}><Icon asChild={true} boxSize={4}><MdOutlinePause /></Icon></IconButton>}</HStack>;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};